import {memo, useCallback} from 'react'

import {dialog} from '../../../../../slices'
import {DialogType} from '../../../../../types'
import IconButton from '../../../../common/IconButton/IconButton'
import {FAVORITE_DIALOG_SIDEBAR_ID} from '../../AgentPoolsFavoritePage/Dialog/AgentPoolsFavoriteDialog.constants'

import {useAppDispatch} from 'src/hooks/react-redux'

interface Props {
  className?: string
}
const openEditDialog = () =>
  dialog.actions.open(FAVORITE_DIALOG_SIDEBAR_ID, DialogType.FAVORITE_AGENT_POOLS)

function AgentsSidebarEditFavoriteComponent(props: Props) {
  const {className} = props
  const dispatch = useAppDispatch()
  const openDialog = useCallback(() => dispatch(openEditDialog()), [dispatch])

  return (
    <IconButton
      className={className}
      icon="pencil"
      onClick={openDialog}
      title="Configure favorites"
    />
  )
}

export const AgentsSidebarEditFavorite = memo(AgentsSidebarEditFavoriteComponent)
